<template>
    <button class="btn btn-sm btn-primary" type="button" disabled>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Loading...
    </button>
</template>

<script>
    export default {
        name: "LoadingButton"
    }
</script>

<style scoped>

</style>